import React from 'react';
import { Mail, Edit3, Sparkles, Send } from 'lucide-react';
import { motion } from 'framer-motion';
const steps = [{
  icon: Mail,
  title: 'Recibís tu email de confirmación',
  desc: 'Llega en minutos. Si no lo ves, revisá tu carpeta de spam o promociones.'
}, {
  icon: Edit3,
  title: 'Respondé al email con tus datos',
  desc: 'Solo necesito tu fecha de nacimiento, tu situación y cualquier detalle específico. Nada más.'
}, {
  icon: Sparkles,
  title: 'Yo hago tu limpieza personalmente',
  desc: 'Sin asistentes ni IA. Cada pedido lo hago yo misma con todo mi cuidado y atención.'
}, {
  icon: Send,
  title: 'Recibís tus resultados',
  desc: 'Tu informe personalizado llega directo a tu correo. Podés responder en cualquier momento con preguntas. Estoy en todo el proceso.'
}];
export function StepsSection() {
  return <section className="w-full py-20 px-4 bg-[#111] border-y border-white/5" data-id="element-292">
      <div className="max-w-4xl mx-auto" data-id="element-293">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-playfair text-3xl sm:text-4xl text-center text-white mb-16" data-id="element-294">
          ¿Qué pasa después de que{' '}
          <span className="text-gradient-gold italic" data-id="element-295">pides tu limpia?</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12" data-id="element-296">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex gap-5" data-id="element-297">
              <div className="flex-shrink-0 flex flex-col items-center" data-id="element-298">
                <div className="w-12 h-12 rounded-full bg-[#1A1A1A] border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37]" data-id="element-299">
                  <step.icon className="w-5 h-5" data-id="element-300" />
                </div>
                {index !== steps.length - 1 && <div className="w-px h-full bg-gradient-to-b from-[#D4AF37]/30 to-transparent mt-4 md:hidden" data-id="element-301" />}
              </div>
              <div className="pb-8 md:pb-0" data-id="element-302">
                <div className="text-[#D4AF37] font-inter text-xs font-bold tracking-wider uppercase mb-1" data-id="element-303">
                  Paso {index + 1}
                </div>
                <h3 className="font-playfair text-xl text-white mb-2" data-id="element-304">
                  {step.title}
                </h3>
                <p className="font-inter text-gray-400 text-sm leading-relaxed" data-id="element-305">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}